<template>
  <v-tooltip left max-width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon small v-on="on">
        <v-icon small v-bind="attrs" v-on="on">fas fa-question-circle</v-icon>
      </v-btn>
    </template>
    <span>{{ helpText }}</span>
  </v-tooltip>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
  props: {
    label: { required: true },
    helpText: { required: true },
  },
};
</script>
